import React from 'react';
import { SubAccount, ClientsAPI } from "src/api"

import PieChart, {
  Series,
  Label,
  Connector,
  // SmallValuesGrouping,
  Legend,
  Size,
  Export
} from 'devextreme-react/pie-chart';
// import data from '../../data/social_pie.json';

type PieProps = {
  client?: SubAccount
}
class PieSocial extends React.Component<PieProps> {
  [x: string]: any;
  constructor(props: Readonly<{}>) {
    super(props);

    // this.pointClickHandler = this.pointClickHandler.bind(this);
    // this.legendClickHandler = this.legendClickHandler.bind(this);
  }
  didUpdateSize(initial: boolean = false) {
    this.chart && this.chart.instance.refresh()
  }
  state = {
    data: undefined,
    narrative: undefined

  }

  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "a4a413db-ba3e-11ea-86cf-0e95a518f8f7",
      report_content_id: "6e06762c-8612-4034-8f0b-bf27bca71701",
      sub_account_id: client.id,
      period_index: "1449",
      period_type: "monthly"
    }

    ClientsAPI.getReportData(client, 'ga_core_social_pie.json').then(result => {
      // console.log('done')
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    ClientsAPI.getNarrative(client, params).then(result => {
      // console.log('done', result)
      this.setState({ narrative: result[0] });
    }).catch(error => {
      // console.log('error', error)
    })
  }
  render() {
    const { data, narrative } = this.state;
    const { client } = this.props;
    // const { narrative } = this.state
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (
      <>
      <PieChart
        id="pie"
        dataSource={data}
        palette="Bright"
        title="Top Social Networks by Sessions"

        // style={{ height: '100%', width: '100%' }}
        ref={(ref) => this.chart = ref}
      >
        <Series
          argumentField="social network"
          valueField="sessions"
        >
          <Label visible={true}
            position="columns"
            customizeText={customizeText}>
            <Connector visible={true} width={1} />
          </Label>
        </Series>

        {/* <Size width={500} /> */}
        <Export enabled={true} />
      </PieChart>
      {JSON.stringify(narrative, null, 2)}
    </>
    );
  }


}

function customizeText(arg: { valueText: any, percentText: any }) {
  return `${arg.valueText} (${arg.percentText})`;
}
export default PieSocial;


// WEBPACK FOOTER //
// ./src/components/ReportComponents/PieSocial.tsx